// Barrel Export für Detail-Komponenten

// Hauptkomponenten
export { BohrpunktComponent } from './bohrpunkt.component';
export { BohrpunktTabsComponent } from './bohrpunkt-tabs.component';
export { BohrpunktNeuComponent } from './bohrpunkt-neu.component';
export { RotationPickerComponent } from './rotation-picker.component';
export { PunktartPickerComponent } from './punktart-picker.component';
export { ReliefPickerComponent } from './relief-picker.component';
export { BohrpunktNummerComponent } from './bohrpunkt-nummer.component';
export { BohrpunktPlausiComponent } from './bohrpunkt-plausi.component';
export { BohrpunktPrintViewComponent } from './bohrpunkt-print-view.component';
export { MultiPrintViewComponent } from './multi-print-view.component';

// Unterverzeichnis-Komponenten
export { BohrpunktAllgemeinComponent } from './bohrpunkt-allgemein/bohrpunkt-allgemein.component';
export { BohrpunktBodenComponent } from './bohrpunkt-boden/bohrpunkt-boden.component';
export { BohrpunktKurzprotokollComponent } from './bohrpunkt-kurzprotokoll/bohrpunkt-kurzprotokoll.component';
export { BohrpunktVegetationComponent } from './bohrpunkt-vegetation/bohrpunkt-vegetation.component';
export { BohrpunktWeitereComponent } from './bohrpunkt-weitere/bohrpunkt-weitere.component';
export { BohrpunktMapComponent } from './bohrpunkt-map/bohrpunkt-map.component';
// SimpleLayoutComponent → verschoben nach @luzula/luzula-lib

// HL-Area-Komponenten (Re-Export)
export * from './hl-area';

// Resolver
export { bohrpunktDetailResolver, bohrpunkteDetailResolver } from './bohrpunkt-detail.resolver';
